import { WelcomeCardFeatureProps } from '../models/welcome-card-props';

export const WelcomeCardFeature: React.FC<WelcomeCardFeatureProps> = ({ icon, label, children }) => (
    <div className="flex items-center gap-2">
        <div className="flex shrink-0 items-center gap-1.5">
            {icon && <s-icon type={icon} tone="success"></s-icon>}
            <div className="text-body-md font-semibold text-icon-success">{label}</div>
        </div>
        <div className="text-body-md">{children}</div>
    </div>
);
